/*
 * Module for handling the list of categories in the categories page
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Messenger, SelectableListModule) {
  var CategoryListController = SelectableListModule.extend({
    /*
     * Overwrite default function to allow a save check before selections
     */
    selectItem: function (clickedModel) {
      //validate the model before switching (if there is a selected model)
      if (!this.selectedModel || this.selectedModel.isValid()) {
        this._selectItem(clickedModel);
      }
    },
    _selectItem: function (clickedModel) {
      if (this.selectedModel !== null) {
        this._markAsUnselected(); //unselect current item
        Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
      }
      this.selectedModel = clickedModel;
      if (this.selectedModel !== null) {
        this._markAsSelected();
        //if the model is removed, then just set this.selectedModel to null
        this.selectedModel.once(
          "remove",
          function () {
            this.selectedModel = null;
          },
          this,
        );
        Messenger.vent.trigger("category:selected", clickedModel);
      }
    },
  });

  return CategoryListController;
});
